<script setup>
import {defineProps} from 'vue'
import {notify} from '@kyvg/vue3-notification'

const props = defineProps({
  id: {
    type: String,
    required: true,
  },
  value: {
    type: String,
    required: true,
  },
})

const copyToClipboard = () => {
  const input = document.getElementById(props.id)
  if (input) {
    navigator.clipboard
      .writeText(input.value)
      .then(() => {
        notify({type: 'success', text: 'Copied to clipboard'})
      })
      .catch(() => {
        notify({type: 'error', text: 'Failed to copy to clipboard'})
      })
  }
}
</script>

<template>
  <button class="copy-btn btn-no-style custom position-relative" @click="copyToClipboard" type="button">
    <input :value="props.value" :id="props.id" type="hidden" />
    <i class="fa-regular fa-clipboard" />
  </button>
</template>
